// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"64d6c36f","453":"a0f369b0","455":"c168e548"}[chunkId] + ".chunk.js";
};